export default __webpack_public_path__ + "static/media/instagram.3a77afb4.svg";